export const containerStyle = {
  width: '100%',
  height: '100%',
  minHeight: '350px',
  borderRadius: 5,
}
